module.exports = __webpack_public_path__ + "static/media/solicita-cnpj.febae8f7.svg";